

























import _Vue, { PropType, VueConstructor } from 'vue'
import { Usuario, UsuarioId, ValorPMultiSelect, PossuiPermissao, DCategoriaDePermissao } from 'src/tipos'
import MensagemDeObservacao from 'src/typescript/common/MensagemDeObservacao'
// import canUseCommonState from 'src/common/mixins/canUseCommonState'

interface Computed {
  useCommonPorPermissao: string;
  usuariosPorPermissao: Usuario;
  valueInterno: ValorPMultiSelect;
  state: Usuario[];
  posssuiPermissaoCriarRegras: PossuiPermissao;
  exibirMensagemDeReplicacaoDaRegra: boolean;
}

interface Props {
  value: UsuarioId[];
  permissao: DCategoriaDePermissao;
  desativado: boolean;
}

const Vue = _Vue as VueConstructor<_Vue & Computed & Props>

export default Vue.extend({
  name: 'UsuariosNotificados',

  components: {
    MensagemDeObservacao
  },

  props: {
    value: {
      type: Array as PropType<UsuarioId[]>,
      required: true,
      default: () => []
    },

    permissao: {
      type: String as PropType<DCategoriaDePermissao>,
      required: true
    },
    desativado: {
      type: Boolean,
      required: false
    }
  },

  computed: {
    useCommonPorPermissao (): string {
      const useCommon = {
        empregado: 'users/usuariosQueSaoEmpregados',
        gestor: 'users/usuariosQueSaoGestores'
      }
      return useCommon[this.permissao]
    },

    usuariosPorPermissao (): Usuario[] {
      return this.$store.getters[`common/${this.useCommonPorPermissao}`]
    },

    exibirMensagemDeReplicacaoDaRegra (): boolean {
      return this.permissao === 'gestor'
    },

    posssuiPermissaoCriarRegras (): PossuiPermissao {
      return {module: 'notificationrules', action: 'post', hide: true}
    },

    valueInterno: {
      get (): ValorPMultiSelect {
        /**
         * O input desse componente é uma lista de ids de usuários, mas o seletor usa um objeto
         * contendo selected e items, sendo respectivamente, os itens selecionados e o todo.
         * Para que o seletor entenda quais itens já tinham sido selecionados é feito um
         * filtro do todo (items) se a lista de ids inclue o id do item representando um usuário.
         * Esses itens filtrados são então colocados na lista de selecionados do seletor (selected).
         */
        const {value: listaDeUsuarioIds, usuariosPorPermissao} = this
        const listaDeTodosOsUsuarios = usuariosPorPermissao
        function verificarSeIdDoUsuarioEstaNaListaDeSelecionados (usuario: Usuario): boolean {
          return listaDeUsuarioIds.includes(usuario.id)
        }

        const usuariosSelecionados = listaDeTodosOsUsuarios.filter(verificarSeIdDoUsuarioEstaNaListaDeSelecionados)

        const opcoesFormatadasDoSeletor = {
          selected: usuariosSelecionados,
          loaded: listaDeTodosOsUsuarios
        }

        return opcoesFormatadasDoSeletor
      },

      set (valueInternoAtualizado: ValorPMultiSelect): void {
        /**
         * Sempre que ocorrer uma alteração no seletor (selecionou/desmarcou um item)
         * o set receberá a atualização com o novo objeto contento items e select.
         * Como o input desse componente é uma lista de ids, então é feito um
         * mapeamentos de todos os ids dos usuários selecionados (selected das opções do seletor).
         * No final essa lista é emitida para que o componente pai faça uso desses ids.
         */
        function pegarIdDoUsuario (usuario: Usuario): UsuarioId {
          return usuario.id
        }
        const usuariosSelecionados = valueInternoAtualizado.selected as Usuario[]
        const listaDeUsuarioIds = usuariosSelecionados.map(pegarIdDoUsuario)

        this.$emit('input', listaDeUsuarioIds)
      }
    }
  }

})
